import { useCallback } from "react";
import { NavigateOptions, To, useNavigate } from "react-router";
import { NewViewTypeEnum } from "../../common/enums/NewViewTypeEnum";

export type NavigateToOptions = {
    newViewType?: NewViewTypeEnum
} & NavigateOptions;

export default function useNavigateTo(): (to: To, options?: NavigateToOptions) => void {

    const navigate = useNavigate();

    const navigateTo = useCallback((to: To, options?: NavigateToOptions) => {

        if (options?.newViewType) {

            switch(options.newViewType) {
                case NewViewTypeEnum.NewTab:
                    window.open(to.toString(), '_blank');
                    break;

                case NewViewTypeEnum.NewWindow:
                    window.open(to.toString(), "_blank", `outerHeight=${window.outerHeight}, outerWidth=${window.outerWidth}, resizable=1, location=0`);                    
                    break;

                default:
                    break;
            }
        } else {

            navigate(to, options);
        }

    }, [
        navigate,
    ]);

    return navigateTo;
}